// docs: https://github.com/altostra/type-validations#readme
import { arrayOf, objectOf } from "@altostra/type-validations";
import { string } from "@altostra/type-validations/lib/primitives";

export const isAppSettingsCustomEventsTagsResult = objectOf({
  all_tags: arrayOf(
    objectOf({
      id: string,
      name: string,
    })
  ),
  used_tags: arrayOf(
    objectOf({
      id: string,
      name: string,
    })
  ),
});
